import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/UI/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Divider from 'Components/UI/Divider';
import { BALANCE_CHART_NAME, CONTRIBUTION_CHART_NAME } from './consts';

const valueFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

const useStyles = buildUseStyles('ManagedAccountActivitySummaryChartTooltip', (theme) => ({
  tooltip: {
    backgroundColor: theme.palette.facet.lightGray,
    padding: theme.spacing(2),
    borderRadius: theme.radius.md,
    outlineWidth: 0,
  },
  chartValues: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  tooltipBalance: {
    marginBottom: theme.spacing(1),
    color: '#007098',
  },
  tooltipContributions: {
    color: '#9C8D49',
  },
}));

export default function ManagedAccountActivitySummaryChartTooltip({ payload, label }) {
  const classes = useStyles();

  if (!payload?.length) return null;

  const date = new Date(label);
  let balance = '0';
  let contribution = '0';
  if (payload) {
    for (const data of payload) {
      if (data.name === BALANCE_CHART_NAME) {
        balance = valueFormatter.format(data.value);
      } else if (data.name === CONTRIBUTION_CHART_NAME) {
        contribution = valueFormatter.format(data.value);
      }
    }
  }


  return (
    <Box className={classes.tooltip}>
      <Typography variant="h6">{date.toLocaleDateString(undefined, {
        day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
      })}
      </Typography>
      <Divider />
      <Box className={classes.chartValues}>
        <Box>
          <Typography variant="h6" color="primaryGray2">{BALANCE_CHART_NAME}</Typography>
          <Typography variant="h6" weight="bold" className={classes.tooltipBalance}>{balance}</Typography>
        </Box>
        <Box>
          <Typography variant="h6" color="primaryGray2">{CONTRIBUTION_CHART_NAME}</Typography>
          <Typography variant="h6" weight="bold" className={classes.tooltipContributions}>{contribution}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
ManagedAccountActivitySummaryChartTooltip.propTypes = {
  payload: PropTypes.array.isRequired,
  label: PropTypes.number.isRequired,
};
